export default __webpack_public_path__ + "static/media/press_room.0d189a18.png";